










































































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';
import DayTimeSlot from '../day-time-slot.vue';

const TODAY: number = new Date(new Date().setHours(0, 0, 0, 0)).valueOf();

@Component({
    components: {
        DayTimeSlot
    }
})
export default class extends Vue {
    currentYear: string = '';
    isAddModal: boolean = true;
    showModal: boolean = false;
    holidayForm: any[] = [];
    activeItem: any = {
        name: '',
        isOfficial: false,
        date: '',
        dateList: [],
        time: '',
        timeList: []
    };

    yearOptions: any = {
        disabledDate(date) {
            const currentDate = new Date(TODAY);
            const yearGap = currentDate.getFullYear() - date.getFullYear();
            let disabledYear = yearGap > 2 || yearGap < 0;
            if (yearGap === -1) {
                disabledYear = false;
            }
            return disabledYear;
        }
    };

    dateOptions: any = {
        disabledDate(date: any) {
            const currentDate = new Date(TODAY);
            return date.getTime() < TODAY || date.getFullYear() > currentDate.getFullYear();
        }
    };

    nextYearDateOptions: any = {
        disabledDate(date: any) {
            const currentDate = new Date(TODAY);
            return date.getFullYear() !== currentDate.getFullYear() + 1;
        }
    };

    spanMethod: Function = ({ row, columnIndex }) => {
        if (row.amount && !row.index && columnIndex === 0) {
            return {
                rowspan: row.amount,
                colspan: 1
            };
        } else if (row.amount && row.index && columnIndex === 0) {
            return {
                rowspan: 0,
                colspan: 0
            };
        }
    };

    get modalTitle() {
        return this.isAddModal ? '新增节假日' : '编辑节假日';
    }

    get ShowAddBtn() {
        const currentDate = new Date(TODAY);
        const year = currentDate.getFullYear();
        return year.toString() === this.currentYear || this.isNextYear;
    }

    get isNextYear() {
        return Number(this.currentYear) === new Date(TODAY).getFullYear() + 1;
    }

    created() {
        this.currentYear = new Date(TODAY).getFullYear().toString();
    }

    mounted() {
        this.getHolidayOncalSetting();
    }

    workTimeChange(val) {
        this.activeItem.timeList = val;
    }

    updateDate(date) {
        this.activeItem.dateList = date;
    }

    async submitEdit() {
        if (!this.activeItem.name || !this.activeItem.dateList) {
            this.$mtd.message.error('请填写名称或日期！');
            return;
        }
        if (!this.activeItem.isOfficial && !this.activeItem.timeList.length) {
            this.$mtd.message.error('非法定节假日工作时间必填！');
            return;
        }
        const dateGap = (this.activeItem.dateList[1] - this.activeItem.dateList[0]) / (1000 * 3600 * 24);
        if (!this.activeItem.isOfficial && dateGap > 19) {
            this.$mtd.message.error('非法定节假日不可超过20天！');
            return;
        }
        if (!this.activeItem.isOfficial && this.isAddModal) {
            this.$mtd
                .confirm({
                    title: '是否确认添加',
                    message: '您添加的日期非法定节假日，添加之后优先按照您配置的节假日值班时间段进行分单和时间统计，是否确认添加',
                    width: '430px',
                    showCancelButton: true,
                    onOk: () => {
                        this.submitHoliday();
                    }
                })
                .catch(() => {});
        } else {
            this.submitHoliday();
        }
    }

    async submitHoliday() {
        const res = await api.rgApi.updateHolidaySetting({
            rgId: this.rgId,
            year: Number(this.currentYear),
            holidayBO: {
                name: this.activeItem.name,
                workTime: this.activeItem.timeList,
                holidayTypeEnum: this.activeItem.isOfficial ? 'OFFICIAL' : 'CUSTOM',
                id: this.activeItem.id,
                dateList: this.activeItem.dateList
            }
        });
        if (res.code === 200) {
            this.showModal = false;
            this.$mtd.message.success(this.isAddModal ? '添加成功' : '编辑成功');
            this.getHolidaySetting(this.currentYear);
        }
    }

    handleEdit(row) {
        this.isAddModal = false;
        this.showModal = true;
        this.activeItem = { ...row };
    }

    handleDelete(row) {
        this.$mtd
            .confirm({
                title: '是否确认删除',
                message: '删除后，该节假日对应的日期将被当做工作日处理，按照工作日设置的工作时间计算响应&处理时长，是否确认删除',
                width: '430px',
                showCancelButton: true,
                onOk: () => {
                    this.deleteHolidaySetting(row);
                }
            })
            .catch(() => {});
    }

    cancelEdit() {
        this.showModal = false;
        this.getHolidaySetting(this.currentYear);
    }

    async getHolidayOncalSetting() {
        const res = await api.rgApi.getHolidayOncalSetting(this.rgId);
        if (res.code === 200 && res.data.workDaysOfWeek) {
            this.holidayForm = this.handleHolidayList(res.data.holidayOnCallHours);
        }
    }

    async getHolidaySetting(val) {
        const res = await api.rgApi.getHolidaySetting({
            rgId: this.rgId,
            year: val
        });
        if (res.code === 200) {
            this.holidayForm = this.handleHolidayList(res.data || {});
        }
    }

    async deleteHolidaySetting(val) {
        const res = await api.rgApi.deleteHolidaySetting(val.id);
        if (res.code === 200) {
            this.$mtd.message.success('删除成功');
            this.getHolidaySetting(this.currentYear);
        }
    }

    handleHolidayList(holidays) {
        const list = [];
        const holidayList = Object.values(holidays || {}).sort((a: any, b: any) => a.dateList[0] - b.dateList[0]);
        holidayList.forEach((holiday: any) => {
            if (holiday.holidayTypeEnum === 'OFFICIAL') {
                const dayMap = Object.values(holiday.singleDayHolidayMap || {}).sort((a: any, b: any) => a.dateList[0] - b.dateList[0]);
                const amount = dayMap.length;
                dayMap.forEach((item: any, index) => {
                    list.push({
                        name: item.name,
                        date: item.displayDate,
                        time: item.displayWorkTime && item.displayWorkTime.join(','),
                        dateList: item.dateList,
                        timeList: item.workTime,
                        isOfficial: item.holidayTypeEnum === 'OFFICIAL',
                        id: item.id || 0,
                        amount,
                        index
                    });
                });
            } else {
                list.push({
                    name: holiday.name,
                    date: holiday.displayDate,
                    time: holiday.displayWorkTime && holiday.displayWorkTime.join(','),
                    dateList: holiday.dateList,
                    timeList: holiday.workTime,
                    isOfficial: holiday.holidayTypeEnum === 'OFFICIAL',
                    id: holiday.id || 0
                });
            }
        });
        return list;
    }

    addHoliday() {
        this.isAddModal = true;
        this.activeItem = {
            name: '',
            isOfficial: false,
            date: '',
            dateList: [],
            time: '',
            timeList: []
        };
        this.showModal = true;
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
